//Custom javascript code here
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".quick_button__alternative").forEach((alternative) => {
        alternative.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent the parent <a> from being clicked
          event.stopPropagation(); // Stop the event from bubbling up
    
          const parent = this.closest("a"); // Find the parent <a> tag
          const quickAdd = parent.querySelector(".product--quick-add"); // Find the quick-add button
    
          if (quickAdd) {
            quickAdd.click(); // Trigger the click on quick--add
          }
        });
     });
});